import Vue from "vue";
import VueRouter from "vue-router";

import VueGtag from "vue-gtag";
import Mainpage from "../components/ResearchPages/Mainpage.vue";

import store from "../store";

Vue.use(VueRouter);


const routes = [{
    path: '/',
    name: 'Home',
    component: Mainpage
},
{
    path: "/KapitmansCorner",
    name: "KapitmansCorner",
    component: require('../components/ResearchPages/KapitsmanCorner').default
},
{
    path: "/TsupitHeroCorner",
    name: "tsupitherocorner",
    component: require('../components/ResearchPages/TsupitHeroCorner').default
},
{
    path: "/Learn",
    name: "learn",
    component: require('../components/ResearchPages/Learn').default
},
{
    path: "/Reports",
    name: "Reports",
    component: require('../components/ResearchPages/Reports').default
},

{
    path: "/Reports/DailyNotes",
    name: "DailyNotes",
    component: require('../components/ResearchPages/ReportsPages/DailyNotes').default
},
{
    path: "/Reports/Archive/DailyNotes",
    name: "DailyNotesArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/DailyNotesArchive.vue').default
},


{
    path: "/Reports/UpcomingDividends",
    name: "UpcomingDividends",
    component: require('../components/ResearchPages/ReportsPages/UpcomingDividends').default
},

{
    path: "/Reports/PreferredShares",
    name: "PreferredDividends",
    component: require('../components/ResearchPages/ReportsPages/PreferredDividends').default
},

{
    path: "/Reports/REITs",
    name: "REITs",
    component: require('../components/ResearchPages/ReportsPages/REITs').default
},

{
    path: "/Reports/EarningScorecard",
    name: "EarningScorecard",
    component: require('../components/ResearchPages/ReportsPages/EarningScorecard').default
},

{

    path: "/Reports/MarketSnapshot",
    name: "MarketSnapshot",
    component: require('../components/ResearchPages/ReportsPages/MarketSnapshot.vue').default
},

{

    path: "/Reports/StockMomentum",
    name: "StockMomentum",
    component: require('../components/ResearchPages/ReportsPages/StockMomentum.vue').default
},

{

    path: "/Reports/CompanyReport",
    name: "CompanyReport",
    component: require('../components/ResearchPages/ReportsPages/CompanyReports.vue').default
},
{

    path: "/Reports/Archive/CompanyReport",
    name: "CompanyReportsArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/CompanyReportArchive.vue').default
},
{

    path: "/Reports/ForecastReport",
    name: "ForecastReport",
    component: require('../components/ResearchPages/ReportsPages/ForecastReport.vue').default
},

{
    path: "/Reports/WeeklyNotes",
    name: "OtherSpeciWeeklyNotesalReports",
    component: require('../components/ResearchPages/ReportsPages/WeeklyNotes.vue').default
},
{
    path: "/Reports/WeeklyNotes/Archive",
    name: "WeeklyNotesArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/WeeklyNotesArchive.vue').default
},


{

    path: "/KapitmansCorner/Archive",
    name: "KapitmansCornerArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/KapitmansCornerArchive.vue').default
},

{
    path: "/KapitmansCorner/Archive/FullReport",
    name: "KapitmansCornerArchive",
    component: require('../components/ResearchPages/FullReports/KapitmansCornerFullReport.vue').default
},
{
    path: "/TsupitHeroCorner/Archive",
    name: "TsupitheroCornerArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/TsupitHeroCornerArchive.vue').default
},
{
    path: "/TsupitHeroCorner/Archive/FullReport",
    name: "KapitmansCornerArchive",
    component: require('../components/ResearchPages/FullReports/TsupitHeroCornerFullReport.vue').default
},
{
    path: "/Reports/PreferredShares/Archive",
    name: "PreferredSharesArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/PreferredSharesArchive.vue').default
},

{
    path: "/Reports/REITs/Archive",
    name: "ReitsArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/ReitsArchive.vue').default
},

{
    path: "/Reports/Archive/MorningPrimer",
    name: "MorningPrimerArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/MorningPrimerArchive.vue').default
},
{
    path: "/Reports/Archive/MarketRecap",
    name: "MarketRecapArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/MarketRecapArchive.vue').default
},
{
    path: "/Reports/SharesBuyback",
    name: "SharesBuyback",
    component: require('../components/ResearchPages/ReportsPages/SharesBuyback.vue').default
},
{
    path: "/Reports/Archive/SharesBuyback",
    name: "SharesBuybackArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/ShareBuybackArchive.vue').default
},

{
    path: "/Reports/Archive/EarningScoreCard",
    name: "EarningScorecardArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/EarningScoreCardArchive.vue').default
},

{
    path: "/MarketCalendar",
    name: "MarketCalendar",
    component: require('../components/ResearchPages/ReportsPages/MarketCalendar.vue').default
},
{
    path: "/Reports/Archive/MarketSnapshots",
    name: "MarketSnapshots",
    component: require('../components/ResearchPages/ReportsPages/Archives/MarketSnapshotArchive.vue').default
},

{
    path: "/Reports/Archive/StocksWithMomentum",
    name: "StocksWithMomentumArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/StockMomentumArchive.vue').default
},

{
    path: "/Reports/IPOReport",
    name: "IPOReport",
    component: require('../components/ResearchPages/ReportsPages/IPOReport.vue').default
},
{
    path: "/Reports/Archive/IPOReport",
    name: "IPOReportArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/IPOReportArchive.vue').default
},

{
    path: "/Reports/TradingPlanReport",
    name: "TradingPlanReport",
    component: require('../components/ResearchPages/ReportsPages/TradingPlanReport.vue').default
},
{
    path: "/Reports/Archive/TradingPlanReport",
    name: "TradingPlanReportArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/TradingPlanReportArchive.vue').default
},

{
    path: "/Reports/TradersMenu",
    name: "TradersMenu",
    component: require('../components/ResearchPages/ReportsPages/TradersNeedToKnow.vue').default
},
{
    path: "/Reports/Archive/TradersMenu",
    name: "TradersMenuArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/TradersNeedToKnowArchive.vue').default
},
{
    path: "/Reports/Archive/PhilstocksForecast",
    name: "PhilstocksForecastArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/PhilstocksForecastArchive.vue').default
},
{
    path: "/Reports/Archive/TradingStrategies",
    name: "TradingStrategiesArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/TradingStrategiesArchive.vue').default
},
{
    path: "/Reports/TradingStrategies",
    name: "TradingStrategies",
    component: require('../components/ResearchPages/ReportsPages/TradingStrategies.vue').default
},
{
    path: "/Reports/InvestingStrategies",
    name: "InvestingStrategies",
    component: require('../components/ResearchPages/ReportsPages/InvestingStrategies.vue').default
},
{
    path: "/Reports/Archive/InvestingStrategies",
    name: "InvestingStrategiesArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/InvestingStrategiesArchive.vue').default
},

{
    path: "/Reports/InvestingStrategies",
    name: "InvestingStrategies",
    component: require('../components/ResearchPages/ReportsPages/InvestingStrategies.vue').default
},
{
    path: "/Reports/OtherSpecialReports",
    name: "OtherSpecialReports",
    component: require('../components/ResearchPages/ReportsPages/EconomicReports.vue').default
},
{
    path: "/Reports/Archive/OtherSpecialReports",
    name: "OtherSpecialReportsArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/EconomicReportsArchive.vue').default
},
{
    path: "/Reports/Archive/IPOPerformance",
    name: "IPOPerformanceArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/IPOPerformanceArchive.vue').default
},
{
    path: "/Reports/IPOPerformance",
    name: "IPOPerformance",
    component: require('../components/ResearchPages/ReportsPages/IPOPerformance.vue').default
},
{
    path: "/Reports/Archive/OfferingsTable",
    name: "OfferingsTableArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/OfferingsTableArchive.vue').default
},
{
    path: "/Reports/OfferingsTable",
    name: "OfferingsTable",
    component: require('../components/ResearchPages/ReportsPages/OfferingsTable.vue').default
},
{
    path: "/Reports/DividendYields",
    name: "DividendYields",
    component: require('../components/ResearchPages/ReportsPages/PSEiDividendYield.vue').default
},
{
    path: "/Reports/Archive/DividendYields",
    name: "DividendYieldsArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/PSEiDividendYieldArchive.vue').default
},
{
    path: "/Reports/Archive/LearningGuide",
    name: "LearningGuideArchive",
    component: require('../components/ResearchPages/ReportsPages/Archives/LearningGuideArchive.vue').default
},
{
    path: "/Reports/LearningGuide",
    name: "LearningGuide",
    component: require('../components/ResearchPages/ReportsPages/LearningGuide.vue').default
},
{
    path: "*",
    name: "PageNotfound",
    component: require('../components/ResearchPages/Error.vue').default
},



];

Vue.use(VueGtag, {
    config: { id: "G-D03H8KRH2Q" },
    appName: '#app',
    pageTrackerScreenviewEnabled: true
}, router);


const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    var config = await store.dispatch('GetConfig');
    var tokenCookie = store.getters["token"];
    var tokenQuery = to.query.t;
    var redirectUrl = `${window.location.origin}${to.fullPath}`;

    if (tokenCookie) {
        await store.dispatch('ValidateToken').catch(() => {
            store.dispatch('DeleteTokenCookie');
            window.location.href = `${config.v5RedirectLink}?redirect=${encodeURIComponent(redirectUrl)}`;
        });

        if (tokenCookie.exp < Date.now() / 1000) { // token expired
            store.dispatch('DeleteTokenCookie');
            window.location.href = `${config.v5RedirectLink}?redirect=${encodeURIComponent(redirectUrl)}`;
        } else {
            next();
        }
    } else if (tokenQuery) {

        store.dispatch('CreateTokenCookie', atob(tokenQuery)).then(async () => {
            await store.dispatch('ValidateToken').catch(() => {
                store.dispatch('DeleteTokenCookie');
                window.location.href = `${config.v5RedirectLink}?redirect=${encodeURIComponent(redirectUrl)}`;
            });
        });

        if (window.location.search) {
            window.location.href = "/";
        } else {
            next();
        }
    } else {
        window.location.href = `${config.v5RedirectLink}?redirect=${encodeURIComponent(redirectUrl)}`;
    }
});

export default router;